import React from "react";

export type StarRatingProps = {
  rating: number | string;
};

const StarRating: React.FC<StarRatingProps> = ({ rating = 3 }) => {
  return Array.from({ length: Number(rating) }, (_, index) => (
    <i key={index} className="star-rating"></i>
  ));
};

export default StarRating;
